
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rankpredictor/gate",
      function () {
        return require("private-next-pages/rankpredictor/gate.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rankpredictor/gate"])
      });
    }
  